import { Directive, HostListener } from '@angular/core';

const MAX_LENGTH = 10;

@Directive({
  selector: '[dateController]'
})
export class DateControllerDirective {

  constructor() { }

  @HostListener('keypress', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.separatorController(event);
  }

  separatorController(event: any): void {
    const length = event.target.value.length;
    if (event.key !== 'Backspace') {

      if (length === 4 || length === 7) {
        event.target.value += '-';
      }

      if (Number.isNaN(Number(event.key)) || length >= MAX_LENGTH || event.key === ' ') {
        event.preventDefault();
      }
    }
  }
}
